<template>
  <div class="content sub">
    <div class="inner_box">
      <div class="mypage_box">
        <div class="mypage_in">
          <slot name="contents" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
<style scoped>
.content.sub{position:relative;padding:40px 0 100px;}

.mypage_top{display:flex; gap:4px; flex-direction: column; margin-bottom:24px;}

.mypage_box{width:792px; margin:0 auto; padding:0 0 80px; position:relative; display: flex; justify-content: center;}
.mypage_box .mypage_top{width:180px; margin-right:24px; flex:none;}
.mypage_box .mypage_in{flex:none; width:588px;}

@media screen and (max-width: 905px) {
  .mypage_box{width:100%; flex-direction: column; }
  .mypage_box .mypage_top{width:100%; margin-right:0;}
  .mypage_box .mypage_in{width:100%;}
}
</style>
